module.exports = __webpack_public_path__ + "img/479.f94f60c1.jpg";